<!--
File Name          : device-settings.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div *ngIf="device">
    <!-- <div>ID: {{device.deviceId}}</div> -->
    <div>Status: {{device.deviceState}}</div>
    <div>Serial Number: {{device.deviceInfo?.deviceSN}}</div>
    <div>Firmware Version: {{device.deviceInfo?.fwMajorVersion}}.{{device.deviceInfo?.fwMinorVersion}}.{{device.deviceInfo?.fwBugVersion}} ({{device.deviceInfo?.fwReleaseType}})</div>
    <div>Hardware Version: {{device.deviceInfo?.hwProductID}}.{{device.deviceInfo?.hwSubcomponentID}}.{{device.deviceInfo?.hwMajorVersion}}.{{device.deviceInfo?.hwMinorVersion}}</div>
    <div>DFU Version: {{device.deviceInfo?.dfuType}}.{{device.deviceInfo?.dfuMajorVersion}}.{{device.deviceInfo?.dfuMinorVersion}}.{{device.deviceInfo?.dfuBugVersion}}</div>
    <div>Bootloader Version: {{device.deviceInfo?.bootType}}.{{device.deviceInfo?.bootMajorVersion}}.{{device.deviceInfo?.bootMinorVersion}}.{{device.deviceInfo?.bootBugVersion}}</div>
    <div>Compile Time: {{device.deviceInfo?.compileTime}}</div>
    <div>Device Time: {{device.deviceTime?.toString()}}</div>


    <dx-button style="margin:8px;" text="Product Support Export" type="default" (onClick)="downloadRawData()"></dx-button>
    <dx-button style="margin:8px;" text="Reset DataSnap" type="default" (onClick)="resetDevice()"></dx-button>
</div>